import React, { useEffect, useRef, useState } from "react";
import "./Banner.css";
import axios from "axios";
import { Link } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import DownArrow from "./Animation/DownArrow";

function Banner() {
  const [data, setData] = useState([]);
  const GetEditData = async () => {
    const response = await axios.get(
      process.env.REACT_APP_BASE_URL_2 + "/without-login/home/website/banner",
    );

    

    setData(response?.data?.data);
  };

  useEffect(() => {
    GetEditData();
  }, []);

  console.log(data, "data");

  return (
    <section className="home_banner_sec">
      <div className="container">
        <div className="slider_main">
          <Swiper
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {data?.map((val) => (
              <SwiperSlide>
                <Link target="_blank" to="https://play.google.com/store/apps/details?id=com.loconex.app">
                  <div className="sliderdiv">
                    <img
                      className="bannerimg"
                      src={process.env.REACT_APP_IMAGE_URL + val?.image}
                      alt="banner-img"
                    />
                  </div>
                </Link>
              </SwiperSlide>
            ))}

            {/* <SwiperSlide>
              <div className='sliderdiv'>
                <img className='bannerimg' src={process.env.PUBLIC_URL + '/assets/images/home/banner/banner.png'} alt="banner-img" />
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className='sliderdiv'>
                <img className='bannerimg' src={process.env.PUBLIC_URL + '/assets/images/home/banner/banner.png'} alt="banner-img" />
              </div>
            </SwiperSlide> */}

            <div className="downloadbtnsec">
              {/* <Link target="_blank" to="https://play.google.com/store/apps">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/googleplay.png"
                  }
                  alt="google-play"
                />
              </Link> */}
              {/* <Link to="#">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/googleplay.png"
                  }
                  alt="google-play"
                />
              </Link>
              <Link to="#">
                <img
                  src={
                    process.env.PUBLIC_URL + "/assets/images/icons/appstore.png"
                  }
                  alt="google-play"
                />
              </Link> */}
            </div>

            {/* <div className="downarrowalign">
              <DownArrow />
            </div> */}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Banner;
